import PropTypes from "prop-types";

import AssignmentFieldHeader from "@/assignments/AssignmentFieldHeader";
import {
  instructionsContainerCss,
  instructionsFieldCss,
} from "./StudentAssignmentInstructions.style";

const propTypes = {
  __cssFor: PropTypes.shape({
    instructions: PropTypes.object,
  }),
  instructions: PropTypes.string,
};

const StudentAssignmentInstructions = ({ instructions, __cssFor }) => {
  const shouldShowInstructions = !(
    instructions === "<p></p>" || instructions === ""
  );
  if (!shouldShowInstructions) return null;

  return (
    <div css={[instructionsContainerCss, __cssFor?.instructions]}>
      <AssignmentFieldHeader>Instructions</AssignmentFieldHeader>
      <div
        // dangerouslySetInnerHTML is required because the instructions are returned as HTML.
        css={instructionsFieldCss}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: instructions }}
      />
    </div>
  );
};

StudentAssignmentInstructions.propTypes = propTypes;

export default StudentAssignmentInstructions;
